import React, { ChangeEvent } from 'react';
import styled from 'styled-components';
import { TinkFontSizes } from '../../providers/ThemeProvider/theme';

const Input = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
`;

const Circle = styled.div`
  display: flex;
  width: ${(props) => props.theme.sizes.normedium};
  height: ${(props) => props.theme.sizes.normedium};
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: 1px solid ${(props) => props.theme.palette.greyBorder.main};
  border-radius: 100%;
  background-color: ${(props) => props.theme.palette.white.main};
  box-shadow: ${(props) => props.theme.shadows.small};
`;

const InnerCircle = styled.div`
  display: flex;
  width: ${(props) => props.theme.sizes.xxsmall};
  height: ${(props) => props.theme.sizes.xxsmall};
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 100%;
  background-color: ${(props) => props.theme.palette.white.main};
`;

type Props = {
  id?: string;
  value: string;
  name: string;
  mb?: TinkFontSizes;
  checked: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  className?: string;
};

const Container = styled.div`
  padding-right: ${(props) => props.theme.sizes.normal};
  ${Input}:checked + ${Circle} {
    background-color: ${(props) => props.theme.palette.primary.main};
    border: none;
  }
  ${Input}[disabled]:checked + ${Circle} {
    background-color: ${(props) => props.theme.palette.primary[400]};
  }
`;

export const Radio: React.FC<Props> = ({ id, value, checked, onChange, name, disabled }) => (
  <Container>
    <Input
      id={id}
      name={name}
      type="radio"
      value={value}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
    />

    <Circle>
      <InnerCircle />
    </Circle>
  </Container>
);
